/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Emitted by `pnpm --filter @nimer/web run routes:generate` from every
 * `src/routes/_registry/manifests/*.manifest.ts`. A branch adds a route by
 * adding its own manifest; nothing hand-edits this file, and nothing hand-edits
 * a shared route array — two beads editing one array merge cleanly, drop a
 * route, and the only thing that notices is a 404 in production.
 *
 * `test/registry.test.ts` regenerates and compares, so an edit here fails CI.
 */
import type { RouteRegistry } from './types.ts'

export const registry: RouteRegistry = [
  {
    id: 'customer.engagement.confirm',
    branch: 'customer',
    path: '/engagements/:customer-ref/confirm',
    plane: 'customer',
    module: 'app/screens/OwnerConfirm.tsx',
    api: ['/api/v1/me/session', '/api/v1/engagements'],
    load: () => import('../../app/screens/OwnerConfirm.tsx'),
  },
  {
    id: 'customer.engagement.deepLink',
    branch: 'customer',
    path: '/e/:customer-ref',
    plane: 'customer',
    module: 'app/screens/DeepLinkResolver.tsx',
    api: ['/api/v1/me/session'],
    load: () => import('../../app/screens/DeepLinkResolver.tsx'),
  },
  {
    id: 'customer.engagement.owner',
    branch: 'customer',
    path: '/engagements/:customer-ref',
    plane: 'customer',
    module: 'app/screens/OwnerAction.tsx',
    api: ['/api/v1/me/engagements', '/api/v1/me/session'],
    load: () => import('../../app/screens/OwnerAction.tsx'),
  },
  {
    id: 'customer.engagement.people',
    branch: 'customer',
    path: '/engagements/:customer-ref/people',
    plane: 'customer',
    module: 'app/screens/OwnerPeople.tsx',
    api: ['/api/v1/engagements'],
    load: () => import('../../app/screens/OwnerPeople.tsx'),
  },
  {
    id: 'customer.engagement.service',
    branch: 'customer',
    path: '/engagements/:customer-ref/service',
    plane: 'customer',
    module: 'app/screens/OwnerService.tsx',
    api: ['/api/v1/me/engagements', '/api/v1/engagements'],
    load: () => import('../../app/screens/OwnerService.tsx'),
  },
  {
    id: 'customer.engagements',
    branch: 'customer',
    path: '/engagements',
    plane: 'customer',
    module: 'app/screens/EngagementChooser.tsx',
    api: ['/api/v1/me/engagements', '/api/v1/me/session'],
    load: () => import('../../app/screens/EngagementChooser.tsx'),
  },
  {
    id: 'customer.progress',
    branch: 'customer',
    path: '/questionnaire/progress',
    plane: 'customer',
    module: 'app/screens/EngagementProgress.tsx',
    api: ['/api/v1/engagements'],
    load: () => import('../../app/screens/EngagementProgress.tsx'),
  },
  {
    id: 'customer.questionnaire',
    branch: 'customer',
    path: '/questionnaire',
    plane: 'customer',
    module: 'app/screens/Questionnaire.tsx',
    api: ['/api/v1/engagements'],
    load: () => import('../../app/screens/Questionnaire.tsx'),
  },
  {
    id: 'customer.questionnaire.section',
    branch: 'customer',
    path: '/questionnaire/s/:section-id',
    plane: 'customer',
    module: 'app/screens/Questionnaire.tsx',
    api: ['/api/v1/engagements'],
    load: () => import('../../app/screens/Questionnaire.tsx'),
  },
  {
    id: 'shell.entry',
    branch: 'shell',
    path: '/',
    plane: 'public',
    module: 'app/screens/PortalEntry.tsx',
    api: [],
    load: () => import('../../app/screens/PortalEntry.tsx'),
  },
]
